import { type ProductImage } from './product-image.interface';

/** Category branch node returned by the store product detail API. */
export interface StoreProductCategory {
  id: number;
  name: string;
  children?: StoreProductCategory[];
}

export interface Product {
  CodProd: string;
  CodTaxs: string;
  Descrip: string;
  Descrip2: string;
  Descrip3: string;
  Existen: number;
  Precio1: number;
  Precio2?: number;
  Precio3?: number;
  priceWithTax: number;
  Refere: string;
  Tax: number;
  isNew?: boolean;
  isFeatured?: boolean;
  productImages: ProductImage[];
  equivalentProducts?: Product[];
  categories?: StoreProductCategory[];
}

export function getFullDescription(p: Product): string {
  return `${p.Descrip} ${p.Descrip2 || ''} ${p.Descrip3 || ''}`.trim();
}
